import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .roomInfo': {
      maxHeight: '277px',
      background: 'white',
      borderRadius: '0',
      padding: '80px 0 60px 0',
      position: 'relative',
      textAlign: 'left',
      width: '100%',
      zIndex: '2',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      [theme.breakpoints.down('lg')]: {
        padding: '50px 0 50px 0px',
        maxHeight: '228px',
      },
      [theme.breakpoints.down('md')]: {
        padding: '40px 0 40px 0px',
        maxHeight: '196px',
      },
      [theme.breakpoints.down('sm')]: {
        padding: '30px 0 30px 20px',
        maxHeight: '230px',
      },
      '&__wrapper': {
        width: '1080px',
        [theme.breakpoints.down('lg')]: {
          width: '940px',
        },
        [theme.breakpoints.down('md')]: {
          width: '700px',
        },
        [theme.breakpoints.down('sm')]: {
          width: '100%',
        },
      },
      '&__title': {
        color: theme.palette.blue1,
        fontFamily: 'ProximaSemibold',
        fontSize: theme.typography.pxToRem(36),
        marginBottom: theme.typography.pxToRem(10),
        lineHeight: '54px',
        [theme.breakpoints.down('lg')]: {
          fontSize: '30px',
          lineHeight: '45px',
        },
        [theme.breakpoints.down('md')]: {
          fontSize: theme.typography.pxToRem(30),
        },
        [theme.breakpoints.down('sm')]: {
          fontSize: '24px',
          lineHeight: '36px',
          maxWidth: '275px',
        },
      },
      '&__details': {
        fontFamily: theme.typography.proxima.regular,
        color: theme.palette.grey1,
        textTransform: 'capitalize',
        fontSize: theme.typography.pxToRem(14),
        [theme.breakpoints.down('md')]: {
          fontSize: theme.typography.pxToRem(16),
          letterSpacing: '0',
        },
        [theme.breakpoints.down('sm')]: {
          fontSize: theme.typography.pxToRem(12),
        },
        '& span': {
          fontSize: '24px',
          lineHeight: '36px',
          display: 'inline-block',
          [theme.breakpoints.down('md')]: {
            fontSize: '18px',
            lineHeight: '27px',
          },
        },
        '& .room-labels': {
          display: 'flex',
          flexWrap: 'wrap',
          '&__label': {
            paddingRight: 8,
            '&::after': {
              content: '", "',
            },
            '&:last-of-type': {
              '&::after': {
                content: '""',
              },
            },
            '&.guarantee': {
              '&::after': {
                content: '""',
                padding: '0 5px',
              },
            },
          },
          [theme.breakpoints.down('sm')]: {
            maxWidth: '236px',
          },
        },
        '&--reservation': {
          lineHeight: theme.typography.pxToRem(27),
          textTransform: 'capitalize',
          fontSize: theme.typography.pxToRem(18),
          marginTop: '10px',
          [theme.breakpoints.down('md')]: {
            fontSize: '16px',
            lineHeight: '24px',
          },
        },
      },
    },
  },
}));

export default useStyles;
